export default __webpack_public_path__ + "static/media/Logo-untos.77dc86ac.png";